/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
}

.qds-vertical,
.qds-vertical-divider,
.qds-tabbar,
.qds-tabs {
  display: flex;
}

.qds-vertical-divider,
.qds-tabbar {
  width: inherit;
}

.qds-arrow-start {
  transform: scaleX(var(--qds-direction-factor, 1)) rotate(180deg);
}

.qds-align-center {
  align-content: center;
}

.qds-hidden {
  display: none;
}

.qds-centered {
  justify-content: center;
}

.qds-tabs {
  flex: 1;
  margin-block: 0;
  overflow: auto;
  padding-inline-start: 0;
  scroll-behavior: smooth;
}

.qds-vertical {
  flex-direction: column;
}

.qds-vertical-divider {
  flex-direction: row;
}

[data-layer='main'] {
  &[data-level='root'] .qds-tabs {
    gap: var(--qds-control-large-gap-siblings-related);
  }

  &[data-level='section'] .qds-tabs {
    gap: var(--qds-control-standard-gap-siblings-related);
  }

  &[data-level='subsection'] .qds-tabs {
    gap: var(--qds-control-small-gap-siblings-related);
  }
}

[data-layer='popup'] {
  &[data-level='root'] .qds-tabs {
    gap: var(--qds-control-standard-gap-siblings-related);
  }

  &[data-level='section'] .qds-tabs {
    gap: var(--qds-control-small-gap-siblings-related);
  }
}

:is([data-layer='panel'], [data-layer='accessory'])[data-level='root']
  .qds-tabs {
  gap: var(--qds-control-small-gap-siblings-related);
}
